<!--首页-->
<template>
	 
		<div class="box">
			<div class="top-box">
				<div class="title">2020年全国啦啦操公开赛</div>
			 	 <van-dropdown-menu>
					<van-dropdown-item v-model="value"  >
						<template #title> 
							<p class="dropdown-item-title">{{option[value].text}}</p>
							<p class="dropdown-item-time">{{option[value].time}}</p>
						</template>
						<div v-for="(item,i) in option" :key="i" class="dropdown-item" @click="dropdownChange1(item)">
							<p>{{item.text}}</p>
							<p>{{item.time}}</p>
						</div>
					</van-dropdown-item>
					<van-dropdown-item v-model="value2"  >
						<template #title> 
							<p class="dropdown-item-title">{{option2[value2].text}}</p>
							<p class="dropdown-item-time">{{option2[value2].time}}</p>
						</template>
						<div v-for="(item,i) in option2" :key="i" class="dropdown-item" @click="dropdownChange2(item)">
							<p>{{item.text}}</p>
							<p>{{item.time}}</p>
						</div>
					</van-dropdown-item>
				</van-dropdown-menu>
			</div>

			<div class="step-box">
				<van-steps direction="vertical" :active="0">
					<van-step v-for="i in 4" :key="i">
						<p class="item-team-name">广州华怡教育小麒麟啦啦队</p>
						<p class='item-team-desc'>5:21  幼儿组-幼儿组-舞蹈啦啦操-花球规定动作</p>
					</van-step>
					 
				</van-steps>	
			</div>
			
 
		</div>

 
</template>
<style scoped>
	/* @import '../../assets/style/index.css'; */
	.item-team-desc{ 
		height:16.5px;
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,0.85);
		line-height:16.5px;
	}
	.item-team-name{
		 
		height:20px;
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(0,0,0,0.85);
		line-height:20px;
	}
	.step-box{width:7.1rem;
	background:rgba(255,255,255,1);
	border-radius:7px;margin:17px auto;overflow: hidden;}

	.dropdown-item{padding-left: 1rem;margin-top: 5px;padding: 0 0 5px 1rem;border-bottom: 1px solid #f5f5f5;}
	.dropdown-item-title{
		height:20px;
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(0,0,0,1);
		line-height:20px;}
	.dropdown-item-time{ 
		height:20px;
		font-size:14px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,1);
		line-height:20px;}
	.top-box >>> [class*=van-hairline]::after{border: none;}
	.top-box{
		height: 2.21rem;width: 100%;background: #fff;padding-bottom: 16px;border-radius: 0 0 10px 10px;
	}
	.title{
		width:100%;
		height:26px;
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(0,0,0,1);
		line-height:26px;
		text-align: center;
		margin:10px 0 20px ;
	}
	.box {
		background: #F8F8F8;
		margin-bottom: 50px;
		overflow: hidden;
	}



</style>

<script>
	import Vue from 'vue'; 
	 import { DropdownMenu, DropdownItem,Step, Steps } from 'vant';

Vue.use(DropdownMenu).use(DropdownItem).use(Step).use(Steps);
	  
	export default {
		name: 'CompetitionOrder',
		components: { 
			 
		},
		data: function () {
			return {
				active: 1,
				value: 1,
				value2:2,
				switch1: false,
				switch2: false,
				option: [
					{ text: '第一比赛日', time: '2020-02-12' ,value:0},
					{ text: '第二比赛日', time: '2020-02-13' ,value:1},
					{ text: '第三比赛日', time: '2020-02-14' ,value:2},
				], 
				option2: [
					{ text: '第一场', time: '14:00~15:00' ,value:0},
					{ text: '第二场', time: '15:00~16:00' ,value:1},
					{ text: '第三场', time: '16:00~17:00' ,value:2},
				], 

			}
		},
		filter: {},
		mounted() {
			document.title = '出场顺序';
			 
			// this.fetch()
		},
		destroyed() {
		},
		methods: {
			onConfirm() {
			this.$refs.item.toggle();
			},
			dropdownChange1(item){
				this.value=item.value
			} ,
			dropdownChange2(item){
				this.value2=item.value

			}

		}
	}
</script>



// WEBPACK FOOTER //
// CompetitionOrder.vue?1330b30a